import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ExclamationTriangleSmallIcon from '@hapana/shared/web/styles/assets/svgs/exclamation-triangle-small.svg'
import AlertDialog from '@hapana/shared/web/components/shared/dialog/alert-dialog/alert-dialog.component'
import {
  SIZES,
  VARIANTS,
} from '@hapana/shared/web/components/shared/dialog/alert-dialog/alert-dialog.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import { TOAST_PROPS_OPTIONS } from '@hapana/shared/web/components/shared/toast/toast.constants'
import { useToast } from '@hapana/shared/web/components/shared/toast/toast.hooks'
import { useRemoveClientFromEquipmentQueue } from '_hooks/equipment-queue.hooks'

export const RemoveFromQueueDialog = ({
  siteId,
  clientId,
  clientName,
  equipmentId,
  equipmentName,
}) => {
  const { t } = useTranslation('checkIn')
  const { popDialog } = useDialog()
  const { openToast } = useToast()

  const { mutate: removeFromQueue, isLoading } = useRemoveClientFromEquipmentQueue({
    onSuccess: () => {
      openToast({
        title: t('equipments.waitline.removedFromQueue', { clientName }),
        severity: TOAST_PROPS_OPTIONS.SEVERITY.SUCCESS,
      })
      popDialog({}, { defaultTab: '2' })
    },
    onError: () => {
      openToast({
        title: t('errors:api.generic'),
        severity: TOAST_PROPS_OPTIONS.SEVERITY.ERROR,
      })
    },
  })

  return (
    <AlertDialog
      title={t('equipments.waitline.removeDialog.title')}
      description={t('equipments.waitline.removeDialog.description', { clientName, equipmentName })}
      icon={ExclamationTriangleSmallIcon}
      size={SIZES.XS}
      variant={VARIANTS.CRITICAL}
      closeAction={popDialog}
      primaryAction={{
        label: t('equipments.waitline.removeDialog.remove'),
        action: () => removeFromQueue({ siteId, clientId, equipmentId }),
        props: { isLoading },
      }}
      secondaryAction={{
        label: t('common:cancel'),
        action: popDialog,
      }}
    />
  )
}

RemoveFromQueueDialog.propTypes = {
  siteId: PropTypes.string,
  clientId: PropTypes.string,
  clientName: PropTypes.string,
  equipmentId: PropTypes.string,
  equipmentName: PropTypes.string,
}

export default RemoveFromQueueDialog
